import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

var ls = new SecureLS({ isCompression: false });

Vue.use(Vuex);

export default new Vuex.Store({
  //plugin that encrypts states and stores in local storage
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ],
  state: {
    jwt: null,
    email: null,
    role: null,
    firstLogin: null,
    userId: null,
    progressStatus: false
  },
  mutations: {
    updateJwt: (state, value) => {
      state.jwt = value;
    },
    updateEmail: (state, value) => {
      state.email = value;
    },
    updateRole: (state, value) => {
      state.role = value;
    },
    updateFirstLogin: (state, value) => {
      state.firstLogin = value;
    },
    updateUserId: (state, value) => {
      state.userId = value;
    },
    switchProgressStatus: (state, value) => {
      state.progressStatus = value;
    }
  }
});
